import { useReducer } from "react";
import { uuidv4 } from "../utils/Helper";

let initialData = {
  activeFile: 0,
  files: [
    {
      id: uuidv4(),
      title: "start.js",
      name: "./start",
      content: `// Happy coding... `,
    },
  ],
};

function filesReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      let files = state.files;
      const newFile = {
        id: uuidv4(),
        title: `script_${files.length}.js`,
        name: `./script_${files.length}`,
        content: `// import some_stuff from './start'`,
      };

      return {
        ...state,
        files: files.concat(newFile),
        activeFile: files.length,
      };
    }
    case "CHOOSE": {
      return {
        ...state,
        activeFile: action.payload.index,
      };
    }
    case "CLOSE": {
      let files = state.files;
      return {
        ...state,
        files: files.filter((_, idx) => idx !== action.payload.index),
        activeFile: action.payload.index - 1,
      };
    }
    case "SAVE": {
      const { files, activeFile } = state;
      let currentFiles = [...files];

      let currentFile = currentFiles.find((_, index) => index === activeFile);
      currentFile = { ...currentFile, content: action.payload.value };

      currentFiles[activeFile] = currentFile;
      return {
        ...state,
        files: currentFiles,
      };
    }
    default: {
      return { ...state };
    }
  }
}

export default function useFiles() {
  const [state, dispatch] = useReducer(filesReducer, initialData);

  function addFile() {
    dispatch({ type: "ADD" });
  }

  function chooseFile(index) {
    dispatch({ type: "CHOOSE", payload: { index } });
  }

  function closeFile(index) {
    dispatch({ type: "CLOSE", payload: { index } });
  }

  function handleSaveFile(value) {
    dispatch({ type: "SAVE", payload: { value } });
  }

  return {
    handleSaveFile,
    addFile,
    chooseFile,
    closeFile,
    files: state.files,
    activeFile: state.activeFile,
  };
}
